import { getMovieSearchUrl, TMDB_API_OPTION } from "./constants";

const searchMovie = async (moviename) => {
  try {
    const url = getMovieSearchUrl(moviename);
    const response = await fetch(url, TMDB_API_OPTION);
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
};

export const searchMovies = async (movienames) => {
  const names = movienames.split(", ");
  const results = await Promise.all(
    names.map(async (name) => {
      const query = name.replaceAll(" ", "%20");
      try {
        const data = await searchMovie(query);
        if (data.results.length > 0) {
          return data.results[0];
        }
      } catch (err) {
        console.error(err);
      }
      return null;
    })
  );
  return results.filter((result) => result !== null);
};
